var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.888 10.414c-.063 0-.123-.027-.165-.075-.151-.172-3.707-4.242-3.707-6.37C.016 1.78 1.749.006 3.888.006c2.138 0 3.871 1.775 3.871 3.965 0 2.127-3.556 6.197-3.707 6.369-.042.048-.102.075-.164.075zm0-9.955C1.995.46.462 2.032.459 3.969c0 1.71 2.724 5.04 3.429 5.873C4.59 9.01 7.316 5.68 7.316 3.97 7.314 2.032 5.78.46 3.888.459z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.888 5.925c-1.104 0-1.998-.916-1.998-2.046s.894-2.046 1.998-2.046c1.103 0 1.998.916 1.998 2.046-.002 1.13-.895 2.045-1.998 2.046zm0-3.637c-.629 0-1.196.387-1.436.982s-.108 1.28.336 1.735c.445.455 1.113.591 1.694.345.581-.247.96-.827.96-1.47C5.44 3 4.746 2.288 3.888 2.287z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/LocationPin.d80f8f6e331722e529c4a3185fb99b76.svg";
export { ForwardRef as ReactComponent };